import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import TripListView from '@/views/TripListView.vue'
import TripDetailLayout from '@/views/TripDetailLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'trip-list',
    component: TripListView
  },
  {
    path: '/join/:tripId/:token',
    name: 'join-preview',
    component: () => import(/* webpackChunkName: "join" */ '@/views/JoinPreviewView.vue')
  },
  {
    path: '/trip/:id',
    component: TripDetailLayout,
    props: true,
    children: [
      { path: '', redirect: 'overview' },
      { path: 'overview', name: 'trip-overview', component: () => import('@/views/trip/OverviewView.vue') },
      { path: 'places', name: 'trip-places', component: () => import('@/views/trip/PlacesView.vue') },
      { path: 'votes', name: 'trip-votes', component: () => import('@/views/trip/VotesView.vue') },
      { path: 'infobox', name: 'trip-infobox', component: () => import('@/views/trip/InfoBoxView.vue') },
      { path: 'todos', name: 'trip-todos', component: () => import('@/views/trip/TodosView.vue') },
      { path: 'finance', name: 'trip-finance', component: () => import('@/views/trip/FinanceView.vue') },
      { path: 'timeline', name: 'trip-timeline', component: () => import('@/views/trip/TimelineView.vue') },
      { path: 'memory', name: 'trip-memory', component: () => import('@/views/trip/MemoryBoxView.vue') },
      { path: 'map', name: 'trip-map', component: () => import('@/views/trip/MapView.vue') },
      { path: 'members', name: 'trip-members', component: () => import('@/views/trip/MembersView.vue') }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.params.id && to.params.id !== store.state.ui.currentTripId) {
    store.dispatch('ui/enterTrip', to.params.id)
  }
  next()
})

export default router
